import { toast } from "react-toastify";

/** Normalizes list payloads from MotoSwipe API responses. */
export const listFromResponse = (res) => {
  const raw = res?.data?.data?.data ?? res?.data?.data ?? res?.data;
  if (Array.isArray(raw)) return raw;
  if (raw && typeof raw === "object") {
    const nested = Object.values(raw).find((v) => Array.isArray(v));
    if (nested) return nested;
  }
  return [];
};

/** Report list payloads: getunseen/getseen use `report[]`; getall uses `data.data[]`. */
export const reportsFromResponse = (res) => {
  if (Array.isArray(res?.report)) return res.report;
  const fromData = listFromResponse(res);
  if (fromData.length) return fromData;
  if (Array.isArray(res?.data?.report)) return res.data.report;
  return [];
};

/** Single report from GET /report/getone/:id */
export const reportFromResponse = (res) =>
  res?.report ?? res?.data?.report ?? res?.data ?? null;

export const getSellerApprovalStatus = (user) => {
  const status = user?.sellerApprovalStatus;
  if (status === "pending_review" || status === "approved" || status === "none") {
    return status;
  }
  const hasDocs =
    user?.isSellerDocumentUploaded === true ||
    user?.isSellerDocumentUploaded === "true" ||
    user?.isSellerDocumentUploaded === 1;
  const approved =
    user?.isSellerAdminApproved === true ||
    user?.isSellerAdminApproved === "true" ||
    user?.isSellerAdminApproved === 1;
  if (hasDocs && !approved) return "pending_review";
  if (hasDocs && approved) return "approved";
  return "none";
};

/** Pending review first, then approved sellers, then others (newest first within group). */
export const sortUsersBySellerStatus = (users) => {
  const order = { pending_review: 0, approved: 1, none: 2 };
  return [...users].sort((a, b) => {
    const oa = order[getSellerApprovalStatus(a)] ?? 2;
    const ob = order[getSellerApprovalStatus(b)] ?? 2;
    if (oa !== ob) return oa - ob;
    return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
  });
};

export const getReportTypeLabel = (row) => {
  const t = row?.reportType || row?.type || row?.report_model_type;
  if (!t) return "—";
  const s = String(t).toLowerCase();
  if (s === "vehicle") return "Vehicle";
  if (s === "user") return "User";
  return String(t);
};

export const isVehicleReport = (row) => {
  const t = String(row?.reportType || row?.type || row?.report_model_type || "").toLowerCase();
  return t === "vehicle";
};

export const getReportedItemSummary = (row) => {
  if (row?.reportedItemSummary) return row.reportedItemSummary;
  const target = row?.report;
  if (!target) return "Item unavailable (may have been deleted)";
  if (isVehicleReport(row)) {
    const parts = [
      target.year,
      target.make,
      target.model,
      target.registration ? `(${target.registration})` : null,
    ].filter(Boolean);
    return parts.length ? parts.join(" ") : "Vehicle";
  }
  return target.name || target.email || "User";
};

/** Mutation responses: treat 200 / 201 / 204 as success so lists refetch after DELETE etc. */
export const isMutationSuccess = (res) => {
  const s = Number(res?.status);
  return s === 200 || s === 201 || s === 204;
};

export const GreenNotify = (text) => {
  toast.success(text, {
    position: toast.POSITION.TOP_CENTER,
  });
};

export const RedNotify = (text) => {
  toast.error(text, {
    position: toast.POSITION.TOP_CENTER,
  });
};
